import { createSelector } from 'reselect';

import { TState } from '~/src/store';
import { ICategory } from '~/src/store/reducers/faq';

export const selectFAQCategories = (state: TState): ICategory[] => state.faq.categories || [];

export const selectAndSortNews = createSelector(
    [selectFAQCategories],
    categories =>  categories.map((category) => ({
        id: category.category_id,
        name: category.category_name,
        slug: category.slug,
    })),
);

export const selectDynamicState = <T>(path: string) => (state: TState): T => {
    const segments = path.split('.');
    return segments.reduce((acc, segment) => acc && acc[segment], state) as T;
};
